import apiClient from './apiClient'


const getCurrentUser = (tenant) => {
  return apiClient.get(`/${tenant}/User/Current`)
}

const getCurrentUserAndProjectClaims = (tenant, userId, projectId) => {
  if (projectId) {
    const params = {
      projectId
    }
    return apiClient.get(`/${tenant}/UserAccess`, { params })
  } else {
    return apiClient.get(`/${tenant}/UserAccess`)
  }
}

const getUsers = (tenant) => {
  return apiClient.get(`/${tenant}/User`)
}

const getUsersShort = (tenant) => {
  return apiClient.get(`/${tenant}/User/Short`)
}

const getUser = (tenant, userId) => {
  return apiClient.get(`/${tenant}/User/${userId}`)
}

const getRelations = (tenant, userId) => {
  return apiClient.get(`/${tenant}/User/${userId}/Relations`)
}

const createUser = (tenant, user) => {
  return apiClient.post(`/${tenant}/User`, user)
}

const setUserIsActive = (tenant, userId, isActive) => {
  return apiClient.put(`/${tenant}/User/${userId}/Active/${isActive}`)
}

const setUserRole = (tenant, userId, roleId) => {
  return apiClient.put(`/${tenant}/User/${userId}/Role/${roleId}`)
}

const updateUser = (tenant, userId, user) => {
  return apiClient.put(`/${tenant}/User/${userId}`, user)
}

const deleteUser = (tenant, userId) => {
  return apiClient.delete(`/${tenant}/User/${userId}`)
}

const inviteUser = (tenant, contactId, data) => {
  return apiClient.post(`/${tenant}/User/Invite/${contactId}`, data)
}

const getManagers = (tenant) => {
  return apiClient.get(`/${tenant}/User/Managers`)
}

export default {
  getCurrentUser,
  getCurrentUserAndProjectClaims,
  getUsers,
  getUsersShort,
  getUser,
  getRelations,
  createUser,
  setUserIsActive,
  setUserRole,
  updateUser,
  deleteUser,
  inviteUser,
  getManagers
}
